import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import checkOrganizationProgram from '../../../../components/check-organization-program';

const PROGRAM_TYPE = 'Market Research';

function getFirstProgram(props) {
  const { programs } = props;
  const program = programs[PROGRAM_TYPE];
  if (program !== undefined && program.length) {
    return program[0];
  }
  return null;
}

class MarketResearch extends Component {
  constructor(props) {
    super(props);
    const firstProgram = getFirstProgram(props);
    this.state = {
      selectedProgramId: firstProgram ? firstProgram.program_id : null,
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    const { selectedProgramId } = this.state;
    if (!selectedProgramId) {
      const firstProgram = getFirstProgram(nextProps);
      if (firstProgram) {
        this.setState({
          selectedProgramId: firstProgram.program_id,
        });
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { selectedProgramId } = this.state;
    return (
      <div className="container">
        <Helmet title="Market Research | Nominations" />
        <div className="alert alert-warning text-center">
          <Fa name="wrench" /> Under Construction
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

MarketResearch.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.element,
};

MarketResearch.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(MarketResearch);
